import { useNavigate, useLocation } from 'react-router-dom';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const menuItems = [
    { path: '/config', label: '社媒项目分析', icon: 'ri-settings-3-line' },
  ];
  
  return (
    <aside className="w-64 bg-[#041327] border-r border-[#0a2540] h-screen fixed left-0 top-0 flex flex-col">
      <div className="h-16 flex items-center justify-center px-6 border-b border-[#0a2540]">
        <h1 className="text-xl font-bold text-white">省博数据中台</h1>
      </div>
      
      <nav className="flex-1 px-4 py-6 space-y-1">
        {menuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              location.pathname === item.path
                ? 'bg-[#4A8AE9]/20 text-[#4A8AE9]'
                : 'text-gray-300 hover:bg-white/5'
            }`}
          >
            <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      
      <div className="p-4 border-t border-[#0a2540]">
        <div className="flex items-center gap-3 px-4 py-3">
          <div className="w-10 h-10 rounded-full bg-[#4A8AE9]/20 flex items-center justify-center">
            <i className="ri-user-line text-[#4A8AE9] text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-200 truncate">管理员</p>
            <p className="text-xs text-gray-400 truncate">admin@museum.com</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
